import { Controller } from "@hotwired/stimulus";

// En-tête du site vitrine : tiroir mobile + menus déroulants (produits, langue, compte).
//
// data-controller="public-nav"
export default class extends Controller {
  static targets = [
    "drawer",
    "openButton",
    "langMenu",
    "langPanel",
    "accountMenu",
    "accountPanel",
    "productsMenu",
    "productsPanel",
    "doorsMenu",
    "doorsPanel",
  ];

  connect() {
    this.onKeydown = this.handleKeydown.bind(this);
    this.onClickOutside = this.handleClickOutside.bind(this);
    document.addEventListener("keydown", this.onKeydown);
    document.addEventListener("click", this.onClickOutside);
  }

  disconnect() {
    document.removeEventListener("keydown", this.onKeydown);
    document.removeEventListener("click", this.onClickOutside);
    this.unlockScroll();
  }

  // --- Tiroir mobile ---------------------------------------------------

  openDrawer() {
    this.closePanels();
    this.drawerTarget.classList.remove("hidden");
    this.openButtonTarget.setAttribute("aria-expanded", "true");
    this.lockScroll();
  }

  closeDrawer() {
    this.drawerTarget.classList.add("hidden");
    this.openButtonTarget.setAttribute("aria-expanded", "false");
    this.unlockScroll();
  }

  get drawerOpen() {
    return this.hasDrawerTarget && !this.drawerTarget.classList.contains("hidden");
  }

  lockScroll() {
    document.body.style.overflow = "hidden";
  }

  unlockScroll() {
    document.body.style.overflow = "";
  }

  // --- Menus déroulants ------------------------------------------------

  toggleLang(event) {
    event.stopPropagation();
    const opening = this.langPanelTarget.classList.contains("hidden");
    this.closePanels();
    if (opening) this.openPanel(this.langPanelTarget, event.currentTarget);
  }

  // Le menu « Produits » (2026-09-14) : GO4LEARN, puis les produits à venir.
  toggleProducts(event) {
    event.stopPropagation();
    const opening = this.productsPanelTarget.classList.contains("hidden");
    this.closePanels();
    if (opening) this.openPanel(this.productsPanelTarget, event.currentTarget);
  }

  // Connexion et Inscription (2026-09-14) : chaque bouton ouvre SON choix de produit.
  toggleDoors(event) {
    event.stopPropagation();
    const panel = event.currentTarget.parentElement.querySelector("[data-public-nav-target='doorsPanel']");
    const opening = panel.classList.contains("hidden");
    this.closePanels();
    if (opening) this.openPanel(panel, event.currentTarget);
  }

  toggleAccount(event) {
    event.stopPropagation();
    const opening = this.accountPanelTarget.classList.contains("hidden");
    this.closePanels();
    if (opening) this.openPanel(this.accountPanelTarget, event.currentTarget);
  }

  openPanel(panel, trigger) {
    panel.classList.remove("hidden");
    panel.classList.add("flex");
    trigger.setAttribute("aria-expanded", "true");
  }

  closePanels() {
    const panels = [this.langPanelTarget, ...this.doorsPanelTargets];
    if (this.hasAccountPanelTarget) panels.push(this.accountPanelTarget);
    if (this.hasProductsPanelTarget) panels.push(this.productsPanelTarget);
    panels.forEach((panel) => {
      panel.classList.add("hidden");
      panel.classList.remove("flex");
      const trigger = panel.parentElement.querySelector("button");
      if (trigger) trigger.setAttribute("aria-expanded", "false");
    });
  }

  // --- Fermetures globales ---------------------------------------------

  handleKeydown(event) {
    if (event.key !== "Escape") return;
    this.closePanels();
    if (this.drawerOpen) this.closeDrawer();
  }

  handleClickOutside(event) {
    if (this.hasLangMenuTarget && this.langMenuTarget.contains(event.target)) return;
    if (this.hasAccountMenuTarget && this.accountMenuTarget.contains(event.target)) return;
    if (this.hasProductsMenuTarget && this.productsMenuTarget.contains(event.target)) return;
    if (this.doorsMenuTargets.some((menu) => menu.contains(event.target))) return;
    this.closePanels();
  }
}
